import React from "react";

function Sidebar({ type, pageHandling }) {
  const styleLink = (linkType) =>
    type === linkType
      ? "bg-indigo-50 text-indigo-600"
      : "text-gray-500 hover:bg-gray-100";
  const styleSvg = (linkType) =>
    type === linkType
      ? "text-indigo-500"
      : "text-gray-400 group-hover:text-gray-500";

  return (
    <ul className="space-y-2 [&>li]:cursor-pointer">
      <li>
        <span
          onClick={() => pageHandling(`details`)}
          className={`${styleLink(
            "details"
          )} w-full group inline-flex items-center py-3 px-4 text-sm font-medium rounded-lg`}
        >
          <svg
            className={`${styleSvg(
              "details"
            )} group-hover:text-gray-500 -ml-0.5 mr-2 h-5 w-5`}
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M10 8a3 3 0 100-6 3 3 0 000 6zM3.465 14.493a1.23 1.23 0 00.41 1.412A9.957 9.957 0 0010 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 00-13.074.003z"></path>
          </svg>
          <span>Details</span>
        </span>
      </li>
      <li>
        <span
          onClick={() => pageHandling(`companies`)}
          className={`${styleLink(
            "companies"
          )} w-full group inline-flex items-center py-3 px-4 text-sm font-medium rounded-lg`}
          aria-current="page"
        >
          <svg
            className={`${styleSvg("companies")} -ml-0.5 mr-2 h-5 w-5`}
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M7 8a3 3 0 100-6 3 3 0 000 6zM14.5 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM1.615 16.428a1.224 1.224 0 01-.569-1.175 6.002 6.002 0 0111.908 0c.058.467-.172.92-.57 1.174A9.953 9.953 0 017 18a9.953 9.953 0 01-5.385-1.572zM14.5 16h-.106c.07-.297.088-.611.048-.933a7.47 7.47 0 00-1.588-3.755 4.502 4.502 0 015.874 2.636.818.818 0 01-.36.98A7.465 7.465 0 0114.5 16z"></path>
          </svg>
          <span>Companies</span>
        </span>
      </li>
      <li>
        <span
          onClick={() => pageHandling(`activity`)}
          className={`${styleLink(
            "activity"
          )} w-full group inline-flex items-center py-3 px-4 text-sm font-medium rounded-lg`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className={`${styleSvg("activity")} -ml-0.5 mr-2 h-5 w-5`}
          >
            <path
              fill-rule="evenodd"
              d="M14.615 1.595a.75.75 0 01.359.852L12.982 9.75h7.268a.75.75 0 01.548 1.262l-10.5 11.25a.75.75 0 01-1.272-.71l1.992-7.302H3.75a.75.75 0 01-.548-1.262l10.5-11.25a.75.75 0 01.913-.143z"
              clip-rule="evenodd"
            />
          </svg>
          <span>Activity</span>
        </span>
      </li>
    </ul>
  );
}

export default Sidebar;
